<template>
  <div class="home">
      <header>
        <h1>Device activation</h1>
        <a href="javascript:history.back()">
            <i class="far fa-times-circle close" />
        </a>
      </header>
      <div class="form-heading">
          <h2>Activate your device</h2>
          <span class="description">
              Enter the code displayed on your device to link it with your mibuilding account.
              You can choose the role of your device later from devices page.
          </span>
          <input
            v-model="value"
            type="text"
            maxlength="7"
            placeholder="e.g: ax1y6b9"
            aria-placeholder="ax1y6b9"/>

          <a href="#" class="btn btn-primary">Activate</a>
          <a href="#" class="only">What is a device?</a>
      </div>
      <!-- TODO: Replace image with catalog of apps with links -->
      <div class="marketing">
          <img src="@/assets/activate-device.svg" width="150px" />
      </div>


  </div>
</template>

<script>

export default {
    name: 'activate-devices',
    data() {
        return {
            value: ''
        }
    }
};
</script>


<style lang="scss" scoped>
</style>
